import { useRouter } from 'next/router';

function isBrowser() {
    return typeof window !== 'undefined';
}

/**
 * @param WrappedComponent
 * @param clientCondition
 * @param serverCondition
 * @param location
 */
export default function withConditionalRedirect({
    WrappedComponent,
    clientCondition,
    getLocation
}) {
    const WithConditionalRedirectWrapper = (props) => {
        const router = useRouter();
        const redirectCondition = clientCondition();
        const location = getLocation({ query: router?.query, asPath: router?.asPath });
        if (isBrowser() && redirectCondition) {
            router.push(location);
            return <></>;
        }
        return <WrappedComponent {...props} />;
    };

    return WithConditionalRedirectWrapper;
}
